import React, { useState, useEffect } from "react";
import "../plan.css";
import {
  Button,
  Form,
  Radio,
  Checkbox,
} from "antd/lib";
import { useDispatch, useSelector } from "react-redux";
import MedicalQuestionSpouse from "./MedicalQuesSpouse";
import MedicalQuestionSelf from "./MedicalQuesSelf";
import MedicalQuestionSon from "./MedicalQuesSon";
import MedicalQuestionDaughter1 from "./MedicQuesDaugh1";
import MedicalQuestionSon2 from "./MedicalQuesSon2";
import MedicalQuestionDaughter2 from "./MedicalQuesDaugh2";
import MedicalQuestionFather from "./MedicalQuesFather";
import MedicalQuestionMother from "./MedicalQuesMother";
import MedicalQuestionFatherInLaw from "./MedicQuesFatherIn";
import MedicalQuestionMotherInLaw from "./MedicQuesMotherIn";
import NullQuestions from "./QuestionNull";
import { HealthQuestions } from "../../../Redux/actions/NumHealth";

const QuestionStep = ({ setShowStep3, Ref3 }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const StoredQuestions = useSelector((state) => state?.healthdetail?.questions)
  const PersonsDetail = useSelector(
    (state) => state?.healthdetail?.famdetail?.healthdetail
  );
  const AddressDetail = useSelector((state) => state?.addressdetail?.info1);
  const CommonData = useSelector((state) => state?.common?.customerDetail)
  const [NoForAll, setNoForAll] = useState(false);
  const [selectedRelationships, setSelectedRelationships] = useState(["Self"]);
  const [RelationArray, setRelationArray] = useState([]);
  const [checkBox, setCheckBox] = useState(false);
  const [showSelfQues, setShowSelfQues] = useState(true);
  const [showSpouseQues, setShowSpouseQues] = useState(false);
  const [showSonQues, setShowSonQues] = useState(false);
  const [showSon2Ques, setShowSon2Ques] = useState(false);
  const [showDaugh1Ques, setShowDaugh1Ques] = useState(false);
  const [showDaugh2Ques, setShowDaugh2Ques] = useState(false);
  const [showFatherQues, setShowFatherQues] = useState(false);
  const [showMotherQues, setShowMotherQues] = useState(false);
  const [showFatherInQues, setShowFatherInQues] = useState(false);
  const [showMotherInQues, setShowMotherInQues] = useState(false);
  const [NullQues, setNullQues] = useState(NullQuestions)
  const [AllData, setAllData] = useState([]);
  const [isAllPresent, setIsAllPresent] = useState(false);

  useEffect(() => {
    form.setFieldsValue({ whoIsInMedic: selectedRelationships });

    const allPersonsInOwnerInfo = PersonsDetail?.every(detail => StoredQuestions?.hasOwnProperty(detail.relationship));
    setIsAllPresent(allPersonsInOwnerInfo);
    // console.log(allPersonsInOwnerInfo)
    const relationships = PersonsDetail?.map(item => item?.relationship) || [];
    setRelationArray(relationships);
  }, [PersonsDetail,StoredQuestions]);

 
  const onAllQuesChange = (e) => {
    const AllValue = e.target.checked;
    console.log(e.target.value)
    console.log(AllValue);
    console.log('RelationArray',RelationArray)
    setCheckBox(AllValue)
    if (AllValue === true) {
      onNoQuestionUpdate()
      setNoForAll(true);
      console.log(selectedRelationships)
      setSelectedRelationships(RelationArray);
      const onlySelf =
        selectedRelationships?.length === 1 &&
        selectedRelationships?.includes("Self");
      setShowSelfQues(onlySelf);
      const onlySpouse =
        selectedRelationships?.length === 1 &&
        selectedRelationships?.includes("Spouse");
      setShowSpouseQues(onlySpouse);
      const onlySon1 =
        selectedRelationships?.length === 1 &&
        selectedRelationships?.includes("Son1");
      setShowSonQues(onlySon1);

      const onlySon2 =
        selectedRelationships?.length === 1 &&
        selectedRelationships?.includes("Son2");
        setShowSon2Ques(onlySon2);

      const OnlyDaughter1 =
        selectedRelationships?.length === 1 &&
        selectedRelationships?.includes("Daughter1");
      setShowDaugh1Ques(OnlyDaughter1);

      const OnlyDaughter2 =
        selectedRelationships?.length === 1 &&
        selectedRelationships?.includes("Daughter2");
        setShowDaugh2Ques(OnlyDaughter2);

        const OnlyFather =
        selectedRelationships?.length === 1 &&
        selectedRelationships?.includes("Father");
        setShowFatherQues(OnlyFather);

        const OnlyMother =
        selectedRelationships?.length === 1 &&
        selectedRelationships?.includes("Mother");
        setShowMotherQues(OnlyMother);

        const OnlyFatherIn =
        selectedRelationships?.length === 1 &&
        selectedRelationships?.includes("FatherInLaw");
        setShowFatherInQues(OnlyFatherIn);

        const OnlyMotherIn =
        selectedRelationships?.length === 1 &&
        selectedRelationships?.includes("MotherInLaw");
        setShowMotherInQues(OnlyMotherIn);

    } else {
      setNoForAll(false);
      setSelectedRelationships([]);
    }
  };
  const handleRelationshipChange = (e) => {
    const relationship = e.target.value;
    const updatedRelationships = selectedRelationships?.includes(relationship)
      ? selectedRelationships?.filter((rel) => rel !== relationship)
      : [...selectedRelationships, relationship];
    // console.log("updatedRelationships", updatedRelationships);
    const onlySelf =
      updatedRelationships?.length === 1 &&
      updatedRelationships?.includes("Self");
    setShowSelfQues(onlySelf);
    
    const onlySpouse =
      updatedRelationships?.length === 1 &&
      updatedRelationships?.includes("Spouse");
    setShowSpouseQues(onlySpouse);
    
    const onlySon1 =
      updatedRelationships?.length === 1 &&
      updatedRelationships?.includes("Son1");
      setShowSonQues(onlySon1);

      const onlySon2 =
      updatedRelationships?.length === 1 &&
      updatedRelationships?.includes("Son2");
        setShowSon2Ques(onlySon2);

      const OnlyDaughter1 =
      updatedRelationships?.length === 1 &&
      updatedRelationships?.includes("Daughter1");
      setShowDaugh1Ques(OnlyDaughter1);

      const OnlyDaughter2 =
      updatedRelationships?.length === 1 &&
      updatedRelationships?.includes("Daughter2");
      setShowDaugh2Ques(OnlyDaughter2);

      const OnlyFather =
      updatedRelationships?.length === 1 &&
      updatedRelationships?.includes("Father");
      setShowFatherQues(OnlyFather);

      const OnlyMother =
      updatedRelationships?.length === 1 &&
      updatedRelationships?.includes("Mother");
      setShowMotherQues(OnlyMother);

      const OnlyFatherIn =
      updatedRelationships?.length === 1 &&
      updatedRelationships?.includes("FatherInLaw");
      setShowFatherInQues(OnlyFatherIn);

      const OnlyMotherIn =
      updatedRelationships?.length === 1 &&
      updatedRelationships?.includes("MotherInLaw");
      setShowMotherInQues(OnlyMotherIn);

      setSelectedRelationships(updatedRelationships);
      const allPersonsInOwnerInfo = PersonsDetail?.every(detail => updatedRelationships?.includes(detail?.relationship));
    //  console.log('allPersonsInOwnerInfo', allPersonsInOwnerInfo);
     setCheckBox(allPersonsInOwnerInfo)
    //  setNoForAll(allPersonsInOwnerInfo)
    form.setFieldsValue({ whoIsInMedic: updatedRelationships });
  };
  const onFinish = (values) => {
    console.log(values)
    setShowStep3(true)
    Ref3.current?.scrollIntoView({ behavior: "smooth" });
  }
  const onNoQuestionUpdate = () => {
    const newHealthQuestions = {};
    
    const selfAndSpouseDetails = PersonsDetail?.filter(person => person?.relationship === "Self" || person?.relationship === "Spouse");
    console.log('selfAndSpouseDetails',selfAndSpouseDetails)
    selfAndSpouseDetails.forEach(detail => {
      const updatedQuestions = NullQues?.map(question => {
    
        const updatedPerson = {
          ...question,
          firstName: detail.relationship === "Self" ? AddressDetail?.Self?.SelfName :
                     detail.relationship === "Spouse" ? AddressDetail?.Spouse?.SpouseName : 'Name',
          lastName: detail.relationship === "Self" ? 'secondName' : 'SpouseSecondName',
          dateOfbirth: detail.relationship === "Self" ? CommonData?.DateOfBirth : 
                      detail.relationship === "Spouse" ? AddressDetail?.Spouse?.dateofbirth : '1997-08-25',
          isInsuredPerson: true,
          isPayer: detail.relationship === "Self" ? true : false,
          isPolicyHolder: detail.relationship === "Self" ? true : false,
          isPrimaryInsuredPerson: detail.relationship === "Self" ? true : false,
          isPrimaryPolicyHolder: detail.relationship === "Self" ? true : false,
          relationship: detail.relationship === "Self" ? 'SELF' : 
                        detail.relationship === "Spouse" ? 'SPOUSE' : 
                        detail.relationship === "Son1" ? 'SON' :
                        detail.relationship === "Son2" ? 'SON' :
                        detail.relationship === "Daughter1" ? 'DAUGHTER' :
                        detail.relationship === "Daughter2" ? 'DAUGHTER' :
                        detail.relationship === "Father" ? 'FATHER':
                        detail.relationship === "Mother" ? 'MOTHER' :
                        ''
        };
        
        let updatedQuestion = updatedPerson;
  
        if (question.hasOwnProperty("addresses")) {
          const updatedAddresses = question.addresses.map(address => ({
            ...address,
            city: AddressDetail?.Self?.City,
            pincode: AddressDetail?.Self?.Pincode,
            state: AddressDetail?.Self?.State,
            street: AddressDetail?.Self?.Address
          }));
      
          updatedQuestion = {
            ...updatedPerson,
            addresses: updatedAddresses
          };
        }
        return updatedQuestion;
      });
  
      newHealthQuestions[detail.relationship] = updatedQuestions;
    });
  console.log('newHealthQuestions',newHealthQuestions)
    // setTimeout(() => {
    //   dispatch(HealthQuestions({...StoredQuestions, ...newHealthQuestions}));
    // }, 500);
  };
  
  return (
    <>
      <Form 
      form={form}
      onFinish={onFinish}
      >
        {PersonsDetail?.length > 1 && (
          <>
            <Form.Item
              name="questions"
              // valuePropName="checked"
              style={{ margin: "12px 32px 0px 32px" }}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const whoIsInMedic = getFieldValue("whoIsInMedic");
                    console.log('whoIsInMedic',!whoIsInMedic)
                    console.log('!value',!value)
                    if (!value && !whoIsInMedic) {
                      return Promise.reject(
                        "Please select the checkbox if your answer is No for all the questions"
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Checkbox 
              onChange={onAllQuesChange} 
              // value={checkBox}
              checked={checkBox}
              >
                No For All Questions
              </Checkbox>
            </Form.Item>
            <div  className="health-ques-opt">
            <Form.Item
              name="whoIsInMedic"
              style={{ marginBottom: "5px" }}
              rules={[
                {
                  required: true,
                  message: "please select",
                },
              ]}
            >
              <Radio.Group
                value={selectedRelationships}
                onChange={handleRelationshipChange}
              >
                {PersonsDetail?.map((item, index) => (
                  <Radio.Button
                    key={index}
                    value={item.relationship}
                    style={{
                      backgroundColor: selectedRelationships?.includes(
                        item.relationship
                      )
                        ? "#293290"
                        : "transparent",
                      color: selectedRelationships?.includes(item.relationship)
                        ? "#fff"
                        : "#293290",
                      borderRightColor: selectedRelationships?.includes(
                        item.relationship
                      )
                        ? "transparent"
                        : "#293290",
                    }}
                  >
                    {item.relationship}
                  </Radio.Button>
                ))}
              </Radio.Group>
            </Form.Item>
            <Form.Item style={{ marginBottom: "5px" }}>
                <Button 
                type="primary" 
                htmlType="submit"
                disabled={isAllPresent === false}
                >Proceed to Nominee Details</Button>
            </Form.Item>
            </div>
          </>
        )}
      </Form>
      {showSelfQues ? (
        <>
          <MedicalQuestionSelf NoForAll={NoForAll} setCheckBox={setCheckBox} setShowStep3={setShowStep3} Ref3={Ref3}/>
        </>
      ) : showSpouseQues ? (
        <MedicalQuestionSpouse NoForAll={NoForAll}/>
      ) : showSonQues ? (
        <MedicalQuestionSon NoForAll={NoForAll}/>
      ) :  showDaugh1Ques ? (
        <MedicalQuestionDaughter1 NoForAll={NoForAll}/>
      ) :  showSon2Ques ? (
        <MedicalQuestionSon2 NoForAll={NoForAll}/>
      ):  showDaugh2Ques ? (
        <MedicalQuestionDaughter2 NoForAll={NoForAll}/>
      ) :  showFatherQues ? (
        <MedicalQuestionFather NoForAll={NoForAll}/>
      ) :  showMotherQues ? (
        <MedicalQuestionMother NoForAll={NoForAll}/>
      ) :  showFatherInQues ? (
        <MedicalQuestionFatherInLaw NoForAll={NoForAll}/>
      ) :  showMotherInQues ? (
        <MedicalQuestionMotherInLaw NoForAll={NoForAll}/>
      )
      : null}
      {/* <div className="text-center">
      <Button 
        type="primary" 
        htmlType="submit"
        disabled={isAllPresent === false}
        >Proceed For Nominee Details
        </Button>
      </div> */}
    </>
  );
};

export default QuestionStep;
